/**
 * Localization messages for useIgnoreBanner hook
 * Following invertedMessages pattern from @saviynt/common
 */
const invertedMessages = {
  'The role recommendation was successfully ignored.':
    'roleRecs.banner.roleIgnoreSuccess',
  'The role could not be ignored due to an internal error.':
    'roleRecs.banner.roleIgnoreError',
} as const;

export default invertedMessages;
